export default {
    deviceReimbursementDate: "15", // days
    consumerFee: "1",
    deviceCopay: "10.01",
    marketValue: "190",
    deviceDeliveryMethod: "shipped",
    paymentGateway: "stripe",
    shippingCountry: "US"
}